import env from "src/core/env";
import { Repository } from "src/core/Repository";
import { AllParentFieldsResponse } from "src/models/directorys/directory";
import { getAllDeliveryReportRequest } from "src/models/phongs/DeliveryReport";
import {
  ICreateHistory,
  IUpdateHistory,
} from "src/models/phongs/historyReport";
import { DeleteRequest } from "src/models/Request";

class HistoryReportRepository extends Repository {
  protected basePath = "/api/cms-service/history-report";

  constructor() {
    super(env.API_CMS_URL);
  }

  getAll(params: getAllDeliveryReportRequest) {
    return this.request<AllParentFieldsResponse>({
      method: "GET",
      url: "/all",
      params,
    });
  }

  createHistory(params: ICreateHistory) {
    return this.request({
      method: "POST",
      url: "",
      data: params,
    });
  }

  exportHistory(id: string) {
    return this.request({
      method: "POST",
      url: `/${id}/export`,
    });
  }

  deleteHistory(param: DeleteRequest) {
    return this.request({
      method: "DELETE",
      url: `/${param.id}`,
    });
  }

  updateHistory(params: IUpdateHistory) {
    return this.request({
      method: "PUT",
      url: "",
      data: params,
    });
  }
}
export const historyReportRepository = new HistoryReportRepository();
